import { createStyles, withStyles } from '@material-ui/core';
import React from 'react';
import { APPLICATION_DRAWER_WIDTH } from '../../const/settings';
import classNames from 'classnames';
import { BACKGROUND_DARK, BACKGROUND_WHITE } from '../../const/color-const';

const styles = createStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: theme.palette.type === 'light' ? BACKGROUND_WHITE : BACKGROUND_DARK,
  },
  wrapperSpacer: {
    ...theme.mixins.toolbar,
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  wrapper: {
    flex: 1,
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  contentWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  contentWrapperSpacer: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: `calc(${APPLICATION_DRAWER_WIDTH}px)`,
    },
  },
  footer: {
    display: 'flex',
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      alignItems: 'center',
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
    },
  },
  logo: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      height: theme.typography.h2.fontSize,
    },
    [theme.breakpoints.up('md')]: {
      height: theme.typography.h5.fontSize,
    },
  },
}));

const AppContent = React.forwardRef((props, ref) => {
  const { controlsVisible, children, classes } = props;
  
  return (
    <div ref={ref} className={classes.root}>
      {controlsVisible && <div className={classes.wrapperSpacer} />}
      <div className={classes.wrapper}>
        <div className={classes.content}>
          <div
            className={classNames(controlsVisible ? [classes.contentWrapper, classes.contentWrapperSpacer] : classes.contentWrapper)}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
});

export default withStyles(styles, { name: 'AppContent' })(AppContent);